// extracted by mini-css-extract-plugin
export default {"profile-info":"ProfileInfo_profile-info__eh0Fi","item":"ProfileInfo_item__h7KRc"};